module.exports = __webpack_public_path__ + "static/lovetap-64cd99b45497e81f856dd7f18140348d.png";